export default {
  title: "Добро пожаловать в личный кабинет",
  description:
    "«ЭКСПОЦЕНТР» – всемирно известная российская выставочно-конгрессная компания, ведущий организатор крупнейших международных отраслевых выставок в России, СНГ и Восточной Европе почти с 60-летним опытом работы.",

  cards: {
    add: "Участвуйте в<br />интересующих <br />выставках",
    notify: "Получайте уведомления <br />по дедлайнам выставки",
    control: "Управляйте своим участием в выставке",
    order: "Заказывайте пропуска <br />и публикуйтесь <br />в каталоге онлайн"
  },

  videoTitle: 'Узнайте больше о AO "ЭКСПОЦЕНТР"',

  howTo: {
    title: "Как принять участие в выставке?",
    step1: "Добавляйте интересующие выставки",
    step2: "Оставляйте заявку на участие",
    step3: "Наш менеджер с вами свяжется и мы заключим договор"
  },

  contact: {
    title: "Остались вопросы? Задавайте их нам!",
    callPhone: "Или позвоните по телефону:"
  }
};
